import { MeasureController } from "../../MeasureController";
import { JudgmentResult, JudgmentResultEnum } from "../../types.client";
import { RemoteMeteringSensitivityMeasure } from "../../../models/schemas/measures/wireless.schema";
import { REMOTE_METERING_THRESHOLDS } from "../../constants/frequencyThresholds";

/**
 * 원격검침 수신감도 컨트롤러
 * 주파수대역별 기준:
 * - 424-447MHz: -110 ~ -100 dBm
 * - 920-923MHz: -137 ~ -110 dBm
 */
export class RemoteMeteringSensitivityController extends MeasureController<RemoteMeteringSensitivityMeasure> {
  protected getDefaultData(): RemoteMeteringSensitivityMeasure {
    return {
      standardValue: 0,
      measuredValue: 0,
      unit: "dBm",
      result: null,
      discussion: "",
      remark: "",
      photo: { checkUrl: "", resultUrl: "" },
      createdAt: null,
    };
  }

  protected judge(): JudgmentResult {
    const { measuredValue = 0 } = this.data;
    const frequencyBand = this.config.extra?.frequencyBand;

    if (!frequencyBand) {
      throw new Error("주파수대역(config.extra.frequencyBand)이 설정되지 않았습니다.");
    }

    const threshold =
      REMOTE_METERING_THRESHOLDS[frequencyBand as keyof typeof REMOTE_METERING_THRESHOLDS];

    if (!threshold) {
      throw new Error(`유효하지 않은 주파수대역: ${frequencyBand}`);
    }

    const result =
      measuredValue >= threshold.min && measuredValue <= threshold.max
        ? JudgmentResultEnum.GOOD
        : JudgmentResultEnum.BAD;
    const discussion = this.generateDiscussion(result);

    return { result, discussion };
  }

  protected generateDiscussion(result: "GOOD" | "CAUTION" | "BAD" | "NA"): string {
    const { measuredValue = 0 } = this.data;
    const frequencyBand = this.config.extra?.frequencyBand || "";
    const threshold =
      REMOTE_METERING_THRESHOLDS[frequencyBand as keyof typeof REMOTE_METERING_THRESHOLDS];

    if (!threshold) {
      return `주파수대역 정보 없음`;
    }

    if (result === JudgmentResultEnum.GOOD) {
      return `측정값 ${measuredValue}dBm, 대역 ${frequencyBand} 기준 ${threshold.min}~${threshold.max}dBm 범위 내로 양호`;
    } else {
      return `측정값 ${measuredValue}dBm, 대역 ${frequencyBand} 기준 ${threshold.min}~${threshold.max}dBm 범위 벗어나 불량`;
    }
  }
}
